/**
 * Flashcard sets access catalog for Pro gating system
 * Defines which flashcard sets are free vs Pro content
 */

import { FlashcardSetCatalog } from '../types/catalog';

export const FLASHCARD_SETS: FlashcardSetCatalog = {
  // Free flashcard sets - basic introductory content
  'psychologie': { 
    title: 'Psychologie', 
    access: 'free' 
  },
  'sociologie': { 
    title: 'Sociologie', 
    access: 'pro' 
  },
  
  // Pro flashcard sets - advanced and specialized content
  'filosofie': { 
    title: 'Filosofie', 
    access: 'free' 
  },
  'pravo': { 
    title: 'Právo', 
    access: 'pro' 
  },
  'politologie': { 
    title: 'Politologie', 
    access: 'pro' 
  },
  'ekonomie': { 
    title: 'Ekonomie', 
    access: 'pro' 
  },
  'moderni-historie': { 
    title: 'Moderní historie', 
    access: 'pro' 
  },
  'evropska-integrace': { 
    title: 'Evropská unie', 
    access: 'pro' 
  },
  
};

/**
 * Get access level for a flashcard set
 * @param setId - The flashcard set ID to check
 * @returns The access level ('free' or 'pro'), defaults to 'free' if not found
 */
export function getFlashcardSetAccess(setId: string): 'free' | 'pro' {
  return FLASHCARD_SETS[setId]?.access || 'free';
}